import {
    FirestoreUser,
    FirestoreUserRole,
    Organization,
} from 'generated/graphql';
import { PartnerState } from 'store/partner/Interfaces/PartnerState';

export function createPartnerState(
    organization: Organization,
    user: FirestoreUser,
): PartnerState {
    const isAdmin = (user.roles || []).includes(
        FirestoreUserRole.OrganizationAdmin,
    );
    const hasPrivateReviews = organization.privateReviews;

    const availableTeamIds =
        hasPrivateReviews && !isAdmin
            ? [user.teamId || organization.defaultTeamView]
            : organization.teams.map((team) => team.key);

    return {
        partnerData: organization,
        teamsForTeamSelector: organization.teams,
        selectedTeamsId: availableTeamIds,
    };
}
